module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TopicsTopEntrance"
  }, [_c('div', {
    staticClass: "TopicsTopEntrance-header"
  }, [_c('div', [_vm._v("跑区详情")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "80px",
      "inline": true,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "跑区名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.queryForm.name),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "name", $$v)
      },
      expression: "queryForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "涉及围栏"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "multiple": ""
    },
    on: {
      "change": _vm.bindFenceChange
    },
    model: {
      value: (_vm.queryForm.fenceIds),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "fenceIds", $$v)
      },
      expression: "queryForm.fenceIds"
    }
  }, _vm._l((_vm.fenceOption), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "id": "map"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-374e3fc3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/runarea/detail.vue
// module id = 989
// module chunks = 0